module.exports = __webpack_public_path__ + "static/media/ape.e3d5ece9.jpg";